// HoC — core interactions (header + menu + scroll-hide)
// Replaces older/partial versions safely.

(() => {
  const root = document.documentElement;

  // Guard: prevent double-init
  if (root.dataset.hocCoreInit === "1") return;
  root.dataset.hocCoreInit = "1";

  const header =
    document.querySelector("[data-hoc-header]") ||
    document.querySelector(".hoc-header");
  const menu =
    document.querySelector("[data-hoc-header-menu]") ||
    document.querySelector(".hoc-header-menu");
  const toggle =
    document.querySelector("[data-hoc-menu-toggle]") ||
    document.querySelector(".hoc-header__menu-toggle");

  if (!header || !menu || !toggle) return;

  const backdrop =
    menu.querySelector("[data-hoc-header-menu-backdrop]") ||
    menu.querySelector(".hoc-header-menu__backdrop");

  // Optional: if your product page has a sticky buyrail, lock it during menu open.
  const buyrail = document.querySelector(".hoc-product__buyrail");
  let buyrailLocked = false;

  let isOpen = toggle.getAttribute("aria-expanded") === "true";

  function lockBuyrail() {
    if (!buyrail || buyrailLocked) return;

    const rect = buyrail.getBoundingClientRect();

    buyrail.dataset.hocPrevPosition = buyrail.style.position || "";
    buyrail.dataset.hocPrevTop = buyrail.style.top || "";
    buyrail.dataset.hocPrevLeft = buyrail.style.left || "";
    buyrail.dataset.hocPrevWidth = buyrail.style.width || "";

    buyrail.style.position = "fixed";
    buyrail.style.top = `${rect.top}px`;
    buyrail.style.left = `${rect.left}px`;
    buyrail.style.width = `${rect.width}px`;

    buyrailLocked = true;
  }

  function unlockBuyrail() {
    if (!buyrail || !buyrailLocked) return;

    buyrail.style.position = buyrail.dataset.hocPrevPosition || "";
    buyrail.style.top = buyrail.dataset.hocPrevTop || "";
    buyrail.style.left = buyrail.dataset.hocPrevLeft || "";
    buyrail.style.width = buyrail.dataset.hocPrevWidth || "";

    delete buyrail.dataset.hocPrevPosition;
    delete buyrail.dataset.hocPrevTop;
    delete buyrail.dataset.hocPrevLeft;
    delete buyrail.dataset.hocPrevWidth;

    buyrailLocked = false;
  }

  function setMenu(open) {
    if (open && !isOpen) lockBuyrail();

    isOpen = open;

    header.classList.toggle("hoc-header--menu-open", open);
    menu.classList.toggle("is-open", open);

    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    menu.setAttribute("aria-hidden", open ? "false" : "true");

    // Scroll lock when menu is open
    root.classList.toggle("hoc-menu-open", open);

    // When menu is open, header must be visible
    if (open) {
      header.classList.add("hoc-header--solid");
      header.classList.remove("hoc-header--hidden");
    } else {
      unlockBuyrail();
    }
  }

  // Toggle menu
  toggle.addEventListener("click", (e) => {
    e.preventDefault();
    setMenu(!isOpen);
  });

  // Backdrop closes menu (desktop/tablet)
  if (backdrop) {
    backdrop.addEventListener("click", (e) => {
      e.preventDefault();
      setMenu(false);
    });
  }

  // ESC closes menu + closes The House subnav details (if open)
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" && e.key !== "Esc") return;

    if (isOpen) setMenu(false);

    document
      .querySelectorAll(".hoc-about__nav-mobile[open]")
      .forEach((d) => d.removeAttribute("open"));
  });

  // ============================
  // Header show/hide on scroll
  // ============================

  let lastY = window.scrollY || 0;
  let ticking = false;

  const SOLID_AT = 40;    // under this: transparent mode
  const HIDE_AT = 120;    // after this: allow hide
  const DELTA_MIN = 4;    // ignore tiny jitters

  function updateHeaderOnScroll() {
    const y = window.scrollY || 0;

    // If menu open: keep header visible/solid
    if (isOpen) {
      header.classList.remove("hoc-header--hidden");
      header.classList.add("hoc-header--solid");
      lastY = y;
      ticking = false;
      return;
    }

    const delta = Math.abs(y - lastY);
    const goingDown = y > lastY;
    const goingUp = y < lastY;

    // Hide when scrolling down
    if (goingDown && y > HIDE_AT && delta > DELTA_MIN) {
      header.classList.add("hoc-header--hidden");
    }

    // Show when scrolling up
    if (goingUp && delta > DELTA_MIN) {
      header.classList.remove("hoc-header--hidden");
    }

    // Solid / transparent logic
    if (y <= SOLID_AT) {
      header.classList.remove("hoc-header--solid");
    } else if (goingUp) {
      header.classList.add("hoc-header--solid");
    } else if (goingDown) {
      header.classList.remove("hoc-header--solid");
    }

    lastY = y;
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (ticking) return;
      window.requestAnimationFrame(updateHeaderOnScroll);
      ticking = true;
    },
    { passive: true }
  );

  window.addEventListener("resize", () => {
    lastY = window.scrollY || 0;
    updateHeaderOnScroll();
  });

  // Initial state
  setMenu(isOpen);
  updateHeaderOnScroll();
})();